<template>
  <CRow>
    <CCol col="12" xl="8">
      <CCard>
        <CCardHeader>
          <strong>Γενικά στοιχεία</strong>
        </CCardHeader>
        <CCardBody class="position-relative">
          <CForm>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
            <CInput 
              horizontal 
              type="text" 
              label="Όνομα" 
              id="name" 
              placeholder="Όνομα" 
              v-model="name">
            </CInput>
            <CButton color="primary" @click="store()">Αποθήκευση</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Multiselect from 'vue-multiselect'

export default {
  name: 'CreateInvoiceService',
  components: {
    Multiselect,
  },
  props: {
    caption: {
      type: String,
      default: 'Create Invoice Service'
    },
  },
  data: () => {
    return {
      showMessage: false,
      message: '',
      dismissSecs: 7,
      alertIsShown: false,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      name: '',
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/clients'})
    },
    store() {
      let self = this;
      axios.post('/api/invoiceservices?token=' + localStorage.getItem("api_token"),
      {
        name: self.name
      })
      .then(function (response) {
        self.message = 'Επιτυχής καταχώρηση υπηρεσίας.';
        self.showAlert();
      }).catch(function (error) {
          if(error.response.data.message == 'The given data was invalid.'){
            self.message = '';
            for (let key in error.response.data.errors) {
              if (error.response.data.errors.hasOwnProperty(key)) {
                self.message += error.response.data.errors[key][0] + '  ';
              }
            }
            self.showAlert();
          }else{
            self.$router.push({ path: '/login' }); 
          }
      });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
}


</script>
